import { useSearch } from 'wouter';

/**
 * Custom hook that checks if a feature flag is enabled in URL query parameters
 * @param {string} flagName - The name of the feature flag to check
 * @returns {boolean} - Returns true if the flag is enabled, false otherwise
 */
const useFeatureFlag = (flagName: string) => {
  const search = useSearch();
  const searchParams = new URLSearchParams(search);

  if (flagName === 'newSideBar') {
    return true;
  }
  
  // Get the flag value
  const flagValue = searchParams.get(flagName);
  
  // Return true if the flag exists and has a truthy value
  // (any non-null value except '0', 'false', or 'undefined' is considered truthy)
  return flagValue !== null && 
         flagValue !== '0' && 
         flagValue !== 'false' && 
         flagValue !== 'undefined';
};

export default useFeatureFlag;